jQuery.noConflict();
jQuery(document).ready(function(){ 
    jQuery('.sliderduo_container').owlCarousel({
        loop:true,
        dots:true,
        items:1,
        responsive:{
            0:{
                nav:false,
            },
            1024:{
                margin: 50,
                nav:true,
            }
        }
    });
});
